import { PersonType } from 'src/utils/constants/clients';

export default (values, legalRepresentativeAval) => ({
  ...values,
  avals:
    values.cededClientPersonType === PersonType.LEGAL && legalRepresentativeAval
      ? [
          {
            ...values.avals[0],
            ...legalRepresentativeAval
          }
        ]
      : values.avals || [],
  isLegalRepresentativeAnAval: values.isLegalRepresentativeAnAval || false
});
